(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zendesk-widget"] && !Shopify.designMode) return;
  try {
    (() => {
    const launcher = document.getElementById('nfd-zendesk-launcher');

    if (!launcher || launcher.dataset.initialized === 'true') {
      return;
    }

    launcher.dataset.initialized = 'true';

    let widgetReady = false;
    let cartDrawerOpen = Boolean(document.getElementById('cart-drawer')?.hasAttribute('open'));

    const setLauncherVisibility = (visible) => {
      launcher.hidden = !visible;
    };

    const hideWidget = () => {
      setLauncherVisibility(false);

      if (!widgetReady || typeof window.zE !== 'function') {
        return;
      }

      window.zE('webWidget', 'close');
      window.zE('webWidget', 'hide');
    };

    const showLauncher = () => {
      if (!widgetReady || cartDrawerOpen || typeof window.zE !== 'function') {
        return;
      }

      window.zE('webWidget', 'hide');
      setLauncherVisibility(true);
    };

    const initializeWidget = () => {
      if (widgetReady || typeof window.zE !== 'function') {
        return;
      }

      widgetReady = true;
      window.zE('webWidget', 'hide');
      window.zE('webWidget:on', 'open', () => setLauncherVisibility(false));
      window.zE('webWidget:on', 'close', showLauncher);
      showLauncher();
    };

    launcher.addEventListener('click', () => {
      if (!widgetReady || cartDrawerOpen || typeof window.zE !== 'function') {
        return;
      }

      setLauncherVisibility(false);
      window.zE('webWidget', 'show');
      window.zE('webWidget', 'open');
    });

    document.addEventListener('dialog:before-show', (event) => {
      if (!(event.target instanceof Element) || event.target.id !== 'cart-drawer') {
        return;
      }

      cartDrawerOpen = true;
      hideWidget();
    }, true);

    document.addEventListener('dialog:after-hide', (event) => {
      if (!(event.target instanceof Element) || event.target.id !== 'cart-drawer') {
        return;
      }

      cartDrawerOpen = false;
      showLauncher();
    }, true);

    const existingScript = document.getElementById('ze-snippet');

    if (existingScript) {
      if (typeof window.zE === 'function') {
        initializeWidget();
      } else {
        existingScript.addEventListener('load', initializeWidget, { once: true });
      }

      return;
    }

    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=756ce04c-fa8c-433d-9d47-6897a079fd59';
    script.async = true;
    script.addEventListener('load', initializeWidget, { once: true });
    document.body.appendChild(script);
  })();
  } catch(e) { console.error(e); }
})();

})();
